import * as React from 'react';
import { IListItem, IWorkflowStatus } from '@nkr/models/index';
import { ControlLabel, FormControl, FormGroup, Panel, ToggleButton, ToggleButtonGroup, Button, ButtonToolbar } from 'react-bootstrap';
import styled from 'styled-components';
import { WorkflowStatusActionType } from "@nkr/enums/index";
import { MobileWrapper } from './styles';

const DropdownButtonWrapper = styled.div`
    & > .dropdown > ul > li > a > .row > .col-xs-5,
    & > .dropdown > ul > li > a > .row > .col-xs-7 {
        padding-left: 5px;
        padding-right: 5px;
    }
`;

interface IProps {
    statusList: IWorkflowStatus[],
    dispositionList: any[],
    sortOrderList: any[],
    onSortOrderChange: (statusId: number, sortOrderId: number) => void,
    addStatus: (statusName: string, dispositionID: number, addFollowUp: boolean, isInEmr: boolean, isRuledOut: boolean, isILDA: boolean) => void,
    handleUpdateConfirmation: (actionType: WorkflowStatusActionType, statusId: number, value: number) => void,
}

interface IState {
    statusList: IWorkflowStatus[],
    dispositionList: IListItem[],
    sortOrderList: any[],
    addNew: boolean,
    statusName: string,
    associatedDisposition: number,
    isInEmr: boolean,
    isRuledOut: boolean,
    isILDA: boolean,
    addFollowUp: boolean
}

class MobileView extends React.Component<IProps, IState> {
    readonly state: IState = {
        statusList: this.props.statusList,
        dispositionList: this.props.dispositionList,
        sortOrderList: this.props.sortOrderList,
        statusName: '',
        associatedDisposition: 0,
        isInEmr: false,
        addFollowUp: false,
        isRuledOut: false,
        isILDA: false,
        addNew: false
    }

    handleDispositionInputChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let value = Number(e.currentTarget.value);

        this.setState({
            associatedDisposition: value
        });
    }

    handleNameInputChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let value = e.currentTarget.value;

        this.setState({
            statusName: value
        });
    }

    toggleAddNew = () => {
        this.setState({
            addNew: !this.state.addNew
        });
    }

    handleInEmrChange = (inEmrVal: boolean) => {
        this.setState({
            isInEmr: inEmrVal
        });
    }

    handleFollowUpChange = (followUpVal: boolean) => {
        this.setState({
            addFollowUp: followUpVal
        });
    }

    handleAddStatus = () => {
        this.props.addStatus(this.state.statusName, this.state.associatedDisposition, this.state.addFollowUp, this.state.isInEmr, this.state.isRuledOut, this.state.isILDA)
        this.setState({
            addNew: false,
            statusName: '',
            associatedDisposition: 0,
            isInEmr: false,
            isILDA: false,
            addFollowUp: false
        });
    }

    render = () => {
        const { statusList, dispositionList, sortOrderList } = this.props;

        return (
            <>
                <MobileWrapper>
                    {statusList.length == 0 && (
                        <div>No status' found...</div>
                    )}

                    {statusList.map(status => {
                        return (
                            <Panel key={'dc-' + status.id}>
                                <Panel.Heading>{status.description}</Panel.Heading>
                                <Panel.Body>
                                    <FormGroup>
                                        <ControlLabel>Disposition</ControlLabel>
                                        <FormControl
                                            componentClass='select'
                                            value={status.associatedDisposition}
                                            onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.props.handleUpdateConfirmation(WorkflowStatusActionType.DispositionUpdate, status.id, parseInt(e.currentTarget.value))}
                                        >
                                            {dispositionList.map((item, index) =>
                                                <option key={'disposition-' + index} value={item.id}>{item.description}</option>
                                            )}
                                        </FormControl>
                                    </FormGroup>

                                    <FormGroup>
                                        <ControlLabel>Is in Emr</ControlLabel>
                                        <br />
                                        <ToggleButtonGroup type='radio' name='swaps' value={status.isInEmr}>
                                            <ToggleButton type='radio' value={1} className={status.isInEmr == true ? 'btn-primary btn-sm' : 'btn-sm'} onClick={() => this.props.handleUpdateConfirmation(WorkflowStatusActionType.isInEmrUpdate, status.id, 1)}>Yes</ToggleButton>
                                            <ToggleButton type='radio' value={2} className={status.isInEmr == false ? 'btn-primary btn-sm' : 'btn-sm'} onClick={() => this.props.handleUpdateConfirmation(WorkflowStatusActionType.isInEmrUpdate, status.id, 0)}>No</ToggleButton>
                                        </ToggleButtonGroup>
                                    </FormGroup>

                                    <FormGroup>
                                        <ControlLabel>Follow-Up Required</ControlLabel>
                                        <br />
                                        <ToggleButtonGroup type='radio' name='swaps' value={status.addFollowUp}>
                                            <ToggleButton type='radio' value={1} className={status.addFollowUp == true ? 'btn-primary btn-sm' : 'btn-sm'} onClick={() => this.props.handleUpdateConfirmation(WorkflowStatusActionType.followUpUpdate, status.id, 1)}>Yes</ToggleButton>
                                            <ToggleButton type='radio' value={2} className={status.addFollowUp == false ? 'btn-primary btn-sm' : 'btn-sm'} onClick={() => this.props.handleUpdateConfirmation(WorkflowStatusActionType.followUpUpdate, status.id, 0)}>No</ToggleButton>
                                        </ToggleButtonGroup>
                                    </FormGroup>

                                    <FormGroup>
                                        <ControlLabel>Sort Order</ControlLabel>
                                        <FormControl
                                            componentClass='select'
                                            value={status.sortOrder}
                                            onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.props.onSortOrderChange(status.id, parseInt(e.currentTarget.value))}
                                        >
                                            {sortOrderList.map((name, index) =>
                                                <option key={'sortOrder-' + index} value={index}>{name}</option>
                                            )}
                                        </FormControl>
                                    </FormGroup>

                                    <Button onClick={() => this.props.handleUpdateConfirmation(WorkflowStatusActionType.Delete, status.id, 0)} bsStyle="danger">Delete</Button>
                                </Panel.Body>
                            </Panel>
                        );
                    })}

                    {!this.state.addNew && (
                        <Button className="pull-right" style={{ marginTop: 40 }}
                            bsStyle="primary"
                            onClick={this.toggleAddNew}>
                            Add Status
                        </Button>
                    )}

                    {this.state.addNew && (
                        <Panel>
                            <Panel.Body>
                                <FormGroup>
                                    <FormControl
                                        placeholder='Status Name...'
                                        name="statusName"
                                        value={this.state.statusName}
                                        onChange={this.handleNameInputChange}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <ControlLabel>DispositionId</ControlLabel>
                                    <FormControl
                                        componentClass='select'
                                        value={this.state.associatedDisposition}
                                        name="associatedDisposition"
                                        onChange={this.handleDispositionInputChange}
                                    >

                                        {
                                            dispositionList.map((name, index) =>
                                                <option key={'disposition-' + index} value={index}>{name}</option>
                                            )
                                        }
                                    </FormControl>
                                </FormGroup>

                                <FormGroup>
                                    <ControlLabel>Is In Emr</ControlLabel>
                                    <br />
                                    <ToggleButtonGroup type='radio' name='swaps' value={this.state.isInEmr}>
                                        <ToggleButton type='radio' value={1} className={this.state.isInEmr == true ? 'btn-primary btn-sm' : 'btn-sm'} onClick={() => this.handleInEmrChange(true)}>Yes</ToggleButton>
                                        <ToggleButton type='radio' value={2} className={this.state.isInEmr == false ? 'btn-primary btn-sm' : 'btn-sm'} onClick={() => this.handleInEmrChange(false)}>No</ToggleButton>
                                    </ToggleButtonGroup>

                                </FormGroup>

                                <FormGroup>
                                    <ControlLabel>Follow-Up Required</ControlLabel>
                                    <br />
                                    <ToggleButtonGroup type='radio' name='swaps' value={this.state.addFollowUp}>
                                        <ToggleButton type='radio' value={1} className={this.state.addFollowUp == true ? 'btn-primary btn-sm' : 'btn-sm'} onClick={() => this.handleFollowUpChange(true)}>Yes</ToggleButton>
                                        <ToggleButton type='radio' value={2} className={this.state.addFollowUp == false ? 'btn-primary btn-sm' : 'btn-sm'} onClick={() => this.handleFollowUpChange(false)}>No</ToggleButton>
                                    </ToggleButtonGroup>
                                </FormGroup>

                                <Button className="pull-right" bsStyle="primary" onClick={this.handleAddStatus}>Save Status</Button>
                            </Panel.Body>
                        </Panel>
                    )
                    }
                </MobileWrapper>
            </>
        );
    }
}

export default MobileView;